import { calledByDevtools } from "@/util/devtools.mjs";

/**
 * This is to catch early on any maintenance issues arising from
 * object keys being changed or removed.
 */
const strictKeyTrap = <T extends object, R>(
  target: T,
  key: string | symbol,
  receiver: R,
) => {
  if (
    typeof key === "string" &&
    !target.hasOwnProperty(key) &&
    !calledByDevtools()
  ) {
    throw new TypeError(`Key "${key}" does not exist.`);
  }

  return Reflect.get(target, key, receiver);
};

export default function makeStrictKeysObject<T extends object>(target: T): T {
  return new Proxy(target, { get: strictKeyTrap });
}
